import { makeStyles } from "@material-ui/core/styles";
import { fontWeight, padding } from "@mui/system";

export default makeStyles({
  displaybar: {
    display: "flex",
    maxHeight: "75vh",
    padding: 50,
    // alignItems: "start",
    ["@media (max-width:1200px)"]: {
      padding: 40,
    },
    ["@media (max-width:959px)"]: {
      padding: 20,
    },
    ["@media (max-width:559px)"]: {
      padding: 5,
      paddingTop: 20,
    },
  },
  box: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    overflow: "scroll",
    height: "65vh",
    ["@media (max-width:959px)"]: {
      paddingTop: 10,
      alignItems: "center",
    },
  },
  card: {
    display: "flex",
    alignItems: "center",
    width: "60%",
    margin: 15,
    paddingLeft: 15,
    color: "#547972",
    fontSize: 16,
    background: "#fefff0",
    borderRadius: 5,
    ["@media (max-width:559px)"]: {
      width: "86%",
    },
  },
});
